<template>
  <section class="has-background-primary is-primary is-fullheight login">
    <div class="hero-body">
      <div class="container has-text-centered">
        <div class="columns">
          <div
            class="column is-8-tablet is-offset-2-tablet is-6-desktop is-offset-3-desktop is-4-widescreen is-offset-4-widescreen"
          >
            <h1 class="title is-size-3 has-text-white">SST Backoffice</h1>
            <p class="subtitle has-text-white">Please login to proceed.</p>
            <div class="box has-text-left">
              <form>
                <b-message type="is-danger" has-icon v-if="loginError">
                  <strong>ungültige Benutzerdaten.</strong>
                  <p>Bitte prüfen Sie Ihre Eingaben.</p>
                </b-message>
                <b-field label="Username">
                  <b-input v-model="userName"></b-input>
                </b-field>

                <b-field label="Password">
                  <b-input
                    type="password"
                    v-model="password"
                    password-reveal
                    @keyup.enter.native="login"
                  ></b-input>
                </b-field>
                <b-button
                  type="is-primary"
                  size="is-medium"
                  expanded
                  @click="login"
                  >Login</b-button
                >
              </form>
            </div>
            <p></p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
  name: 'LoginWindow',
  computed: {
    ...mapGetters({
      loginError: 'loginError',
    }),
  },
  data() {
    return {
      userName: '',
      password: '',
    }
  },
  methods: {
    login() {
      this.$store.dispatch('login', {usr: this.userName, pwd: this.password})
    },
  },
}
</script>

<style lang="scss" scoped>
// .hero {
//   &.is-fullheight {
//     .hero-body {
//       align-items: flex-start;
//     }
//   }
// }

.login {
  height: 100vh;
  margin-top: -5rem;
}
</style>
